import React, { useMemo, useState } from "react";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Divider, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { ReactComponent as CrossInCircleIcon } from "assets/icons/cross-in-circle.svg";
import { ReactComponent as TickHalfCircleIcon } from "assets/icons/tick-half-circle.svg";

interface Props {
  markAllAsRead?: () => void;
  markAsRead?: () => void;
  markAsUnread?: () => void;
  remove?: () => void;
}

type Option = {
  icon: JSX.Element;
  title: string;
  handleClick: () => void;
};

export const NotificationMenu: React.FC<Props> = ({ markAllAsRead, markAsRead, markAsUnread, remove }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const options: Array<Option> = useMemo(() => {
    const result: Array<Option> = [];

    if (markAsRead) {
      result.push({
        title: "Mark as Read",
        icon: <TickHalfCircleIcon className="icon" />,
        handleClick: markAsRead
      });
    }

    if (markAsUnread) {
      result.push({
        title: "Mark as Unread",
        icon: <TickHalfCircleIcon className="icon" />,
        handleClick: markAsUnread
      });
    }

    if (markAllAsRead) {
      result.push({
        title: "Mark All as Read",
        icon: <TickHalfCircleIcon className="icon" />,
        handleClick: markAllAsRead
      });
    }

    if (remove) {
      result.push({
        title: "Remove Notification",
        icon: <CrossInCircleIcon className="icon" />,
        handleClick: remove
      });
    }

    return result;
  }, [markAsRead, markAsUnread, markAllAsRead, remove]);

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map(({ title, handleClick, icon }, index) => (
          <>
            <MenuItem
              key={index}
              onClick={() => {
                handleClick();
                handleClose();
              }}
              sx={{ p: "0 16px" }}
            >
              <Stack direction="row" sx={{ alignItems: "center", height: 32, gap: "10px" }}>
                {icon} {title}
              </Stack>
            </MenuItem>
            {index !== options.length - 1 && <Divider />}
          </>
        ))}
      </Menu>
    </>
  );
};
